// 3rd party
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// components
import { InstrumentComponent } from 'app/instruments/instrument/instrument.component';
import { BudgetComponent } from 'app/budgets/budget/budget.component';
import { StandardCalibrationComponent } from 'app/standards/standard-calibration/standard-calibration.component';
import { CalibrationComponent } from 'app/calibrations/calibration/calibration.component';
import { ReportListComponent } from 'app/reports/report-list/report-list.component';
import { LoginFeedComponent } from 'app/login/login-feed/login-feed.component';
import { SampleListComponent } from 'app/assays/samples/sample-list/sample-list.component';
import { LayoutMainComponent } from 'app/shared/layout/layout-main/layout-main.component';
import { UnauthorizedPageComponent } from 'app/shared/pages/error/unauthorized-page.component';
import { InstrumentListComponent } from 'app/instruments/instrument-list/instrument-list.component';
import { CalibrationListComponent } from 'app/calibrations/calibration-list/calibration-list.component';
import { BudgetListComponent } from 'app/budgets/budget-list/budget-list.component';
import { StandardCalibrationListComponent } from 'app/standards/standard-calibration-list/standard-calibration-list.component';
import { SampleComponent } from 'app/assays/samples/sample/sample.component';
import { AssayListComponent } from 'app/assays/assay-list/assay-list.component';
import { AssayComponent } from 'app/assays/assay/assay.component';
import { ActivityVerifyComponent } from 'app/verify/activity-verify/activity-verify.component';

// services
import { AuthGuard, AuthGuardLogin, AuthGuardInstruments, AuthGuardCalibrations, AuthGuardBudgets, AuthGuardStandards, AuthGuardReports, AuthGuardLogout, AuthGuardAssays } from 'app/shared/services/auth/auth.guard';

const appRoutes: Routes = [
  { path: 'login', component: LoginFeedComponent, canActivate: [AuthGuardLogin] },
  { path: 'logout', component: LoginFeedComponent, canActivate: [AuthGuardLogout] },
  { path: ':domain/activity-verify/:identifier', component: ActivityVerifyComponent },
  {
    path: ':domain', component: LayoutMainComponent, canActivate: [AuthGuard], canLoad: [AuthGuard],
    children: [
      { path: '', redirectTo: 'instruments', pathMatch: 'full' },
      { path: 'unauthorized', component: UnauthorizedPageComponent },
      {
        path: 'instruments', component: InstrumentListComponent, canActivate: [AuthGuardInstruments], canLoad: [AuthGuardInstruments], children: [
          { path: ':identifier', component: InstrumentComponent }
        ]
      },
      {
        path: 'samples', component: SampleListComponent, canActivate: [AuthGuardAssays], canLoad: [AuthGuardAssays], children: [
          { path: ':identifier', component: SampleComponent }
        ]
      },
      {
        path: 'calibrations', component: CalibrationListComponent, canActivate: [AuthGuardCalibrations], canLoad: [AuthGuardCalibrations], children: [
          { path: ':identifier', component: CalibrationComponent }
        ]
      },
      {
        path: 'assays', component: AssayListComponent, canActivate: [AuthGuardAssays], canLoad: [AuthGuardAssays], children: [
          { path: ':identifier', component: AssayComponent }
        ]
      },
      {
        path: 'budgets', component: BudgetListComponent, canActivate: [AuthGuardBudgets], canLoad: [AuthGuardBudgets], children: [
          { path: ':identifier', component: BudgetComponent }
        ]
      },
      {
        path: 'standards', component: StandardCalibrationListComponent, canActivate: [AuthGuardStandards], canLoad: [AuthGuardStandards], children: [
          { path: ':identifier', component: StandardCalibrationComponent }
        ]
      },
      { path: 'reports', component: ReportListComponent, canActivate: [AuthGuardReports], canLoad: [AuthGuardReports] }
    ]
  },

  // redirect
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  // page not found redirect to initial page
  { path: '**', redirectTo: 'instruments' }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRouting { }



// WEBPACK FOOTER //
// ./src/app/app.routing.ts